import { Flex } from "@sidelinesports/fan-design-system";
import { UploadedImage } from "../../../../components/UploadedImage.tsx";
import { useCurrentGameQuery } from "../../hooks/use-current-game.ts";

export const SponsorSection = () => {
  const gameQuery = useCurrentGameQuery();

  const sponsor = gameQuery.data?.gameSponsor;

  if (!sponsor) {
    return null;
  }

  return (
    <Flex align="center" justify="center">
      <UploadedImage
        image={sponsor.image}
        alt="Game sponsor"
        maxWidth="15rem"
        objectFit="contain"
        tracking={{
          location: "PlayGame::SponsorLogo",
        }}
      />
    </Flex>
  );
};
